module.exports = __webpack_public_path__ + "img/img-archive01.35e9a4b0.png";